import { render, staticRenderFns } from "./ServiceOrderDetail.vue?vue&type=template&id=036c7718&scoped=true"
import script from "./ServiceOrderDetail.vue?vue&type=script&lang=js"
export * from "./ServiceOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrderDetail.vue?vue&type=style&index=0&id=036c7718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c7718",
  null
  
)

export default component.exports